(() => {
  const article = document.querySelector('.nr-article');
  const tools = article?.querySelector('[data-nr-tools]');
  const content = article?.querySelector('.article__content');
  if (!article || !tools || !content) return;

  const headings = [...content.querySelectorAll('h2, h3, h4')].filter((heading) => heading.textContent.trim());
  const boldLabels = [...content.querySelectorAll('p')].filter((paragraph) => {
    const strong = paragraph.querySelector(':scope > strong, :scope > b');
    return strong && paragraph.textContent.trim() === strong.textContent.trim() && strong.textContent.trim().length < 100;
  });
  const usedIds = new Set([...document.querySelectorAll('[id]')].map((node) => node.id));
  const targetId = (heading) => {
    if (heading.id) return heading.id;
    const stem = heading === content ? `nr-recipe-${article.dataset.sectionId}` : `nr-section-${article.dataset.sectionId}-${heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 48) || 'section'}`;
    let id = stem;
    let number = 2;
    while (usedIds.has(id)) id = `${stem}-${number++}`;
    heading.id = id;
    usedIds.add(id);
    return id;
  };
  const addLink = (label, heading) => {
    const link = document.createElement('a');
    link.className = 'nr-article__tool';
    link.href = `#${targetId(heading)}`;
    link.textContent = label;
    heading.tabIndex = -1;
    heading.classList.add('nr-article__jump-target');
    
    tools.append(link);
  };

  if (tools.dataset.nrKind === 'recipe') {
    const markers = [...content.querySelectorAll('h2, h3, h4, p')].filter((node) => headings.includes(node) || boldLabels.includes(node));
    const hasSectionContent = (heading) => {
      let node = heading.nextElementSibling;
      let text = '';
      while (node && !markers.includes(node)) {
        text += ` ${node.textContent.trim()}`;
        if (text.trim().length >= 20) return true;
        node = node.nextElementSibling;
      }
      return false;
    };
    const ingredients = markers.find((heading) => /^(ingredients?(?:\s+(?:for|you(?:'|’)?ll need)\b.*)?|what you(?:'|’)?ll need)\s*:?$/i.test(heading.textContent.trim()) && hasSectionContent(heading));
    const instructions = markers.find((heading) => /^(instructions?|directions?|method|preparation(?:\s+instructions?)?|how to make(?:\s+.+)?)\s*:?$/i.test(heading.textContent.trim()) && hasSectionContent(heading));
    if (ingredients) addLink(tools.dataset.nrIngredients, ingredients);
    if (instructions) addLink(tools.dataset.nrInstructions, instructions);
    if (!ingredients && !instructions) addLink(tools.dataset.nrRecipe, content);
  } else {
    const tocHeadings = headings.filter((heading) => heading.tagName === 'H2' || heading.tagName === 'H3');
    if (tocHeadings.length >= 3 && content.textContent.trim().length >= 1200) {
      const nav = document.createElement('nav');
      nav.className = 'nr-article__toc';
      nav.setAttribute('aria-label', tools.dataset.nrToc);
      const title = document.createElement('h2');
      title.className = 'nr-article__toc-title';
      title.textContent = tools.dataset.nrToc;
      const list = document.createElement('ol');
      tocHeadings.slice(0, 12).forEach((heading) => {
        const item = document.createElement('li');
        if (heading.tagName === 'H3') item.className = 'nr-article__toc-subitem';
        const link = document.createElement('a');
        link.href = `#${targetId(heading)}`;
        link.textContent = heading.textContent.trim();
        heading.tabIndex = -1;
        
        item.append(link);
        list.append(item);
      });
      nav.append(title, list);
      tools.after(nav);
    }
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.nr-article__toc a, a.nr-article__tool');
    if (!link || !link.closest('.nr-article') || !link.hash) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    history.pushState(null, '', link.hash);
    target.tabIndex = -1;
    target.scrollIntoView({ block: 'start', behavior: 'auto' });
    target.focus({ preventScroll: true });
  }, true);

  const print = document.createElement('button');
  print.type = 'button';
  print.className = 'nr-article__tool nr-article__print';
  print.textContent = tools.dataset.nrPrint;
  print.addEventListener('click', () => {
    document.body.classList.add('nr-article-print');
    window.print();
  });
  window.addEventListener('afterprint', () => document.body.classList.remove('nr-article-print'));
  tools.append(print);
  tools.hidden = false;
})();
